<div>{{ event().eventTitle }}</div>
